<div>{{ event().eventTitle }}</div>
